module.exports = __webpack_public_path__ + "static/img/logo-large@3x.242f37a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-large@3x.png
// module id = FlIl
// module chunks = 1